export class ReturnConditionData {

  private _idf: String;
  private _fixedFeePerPacket: number;
  private _returnDeadlineOrderError: number;
  private _returnDeadlineExpiry: number;
  private _processingFee: number;
  private _fixedFeeHighPrice: number;
  private _fixedFeeBtmCool: number;
  private _minimumValueBtmCool: number;
  private _returnDeadlineBtmCool: number;

  constructor(obj: any = {}) {
    this._idf = obj && obj._idf || null;
    this._fixedFeePerPacket = obj && obj.fixed_fee_per_packet || 0;
    this._returnDeadlineOrderError = obj && obj.return_deadline_order_error || 0;
    this._returnDeadlineExpiry = obj && obj.return_deadline_expiry || 0;
    this._processingFee = obj && obj.processing_fee || 0;
    this._fixedFeeHighPrice = obj && obj.fixed_fee_high_price || 0;
    this._fixedFeeBtmCool = obj && obj.fixed_fee_btm_cool || 0;
    this._minimumValueBtmCool = obj && obj.minimum_value_btm_cool || 0;
    this._returnDeadlineBtmCool = obj && obj.return_deadline_btm_cool || 0;
  }


  get idf(): String {
    return this._idf;
  }

  get fixedFeePerPacket(): number {
    return this._fixedFeePerPacket;
  }

  get returnDeadlineOrderError(): number {
    return this._returnDeadlineOrderError;
  }

  get returnDeadlineExpiry(): number {
    return this._returnDeadlineExpiry;
  }

  get processingFee(): number {
    return this._processingFee;
  }

  get fixedFeeHighPrice(): number {
    return this._fixedFeeHighPrice;
  }

  get fixedFeeBtmCool(): number {
    return this._fixedFeeBtmCool;
  }

  get minimumValueBtmCool(): number {
    return this._minimumValueBtmCool;
  }

  get returnDeadlineBtmCool(): number {
    return this._returnDeadlineBtmCool;
  }
}
